import { render, staticRenderFns } from "./ChangeCustomerPhoneAlertModal.vue?vue&type=template&id=a357f0ac&"
import script from "./ChangeCustomerPhoneAlertModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeCustomerPhoneAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports